import { render, staticRenderFns } from "./vip_login.vue?vue&type=template&id=deaf73f6&scoped=true&"
import script from "./vip_login.vue?vue&type=script&lang=js&"
export * from "./vip_login.vue?vue&type=script&lang=js&"
import style0 from "./vip_login.vue?vue&type=style&index=0&id=deaf73f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deaf73f6",
  null
  
)

export default component.exports